<template>
  <el-card class="box-card">
    <div class="searchCommon">
      <el-form ref="searchForm"
               class="search"
               label-position="right"
               label-width="80px"
               :model="formLabelAlign">
        <el-form-item v-for="(item,index) in searchArray"
                      :key="index"
                      class="item_label"
                      :label="item.label">
          <el-input v-if="item.type==='input'"
                    v-model="formLabelAlign[item.props]"
                    clearable
                    :placeholder="'请输入'+item.label"
                    @keyup.enter.native="(e)=>onSubmit(e,formLabelAlign)" />
          <el-select v-else-if="item.type==='select'"
                     v-model="formLabelAlign[item.props]"
                     filterable
                     clearable
                     :placeholder="'请选择'+item.label">
            <el-option v-for="(g,i) in item.list"
                       :key="i"
                       :label="g.name"
                       :value="g.id" />
          </el-select>
          <el-date-picker v-else-if="item.type==='date'"
                          v-model="formLabelAlign[item.props]"
                          type="date"
                          placeholder="选择日期"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd" />
          <Cascader v-else-if="item.type==='cascader'"
                    v-model="formLabelAlign[item.props]" />
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <slot name="btn"></slot>
        <el-button class="btn"
                   @click="resetForm">
          重置
        </el-button>
        <el-button class="btn"
                   type="primary"
                   @click="(e)=>onSubmit(e,formLabelAlign)">
          搜索
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
// eslint-disable-next-line
import Cascader from '@/components/searchSite/index.vue';

export default {
  components: { Cascader },
  props: {
    searchArray: {
      type: Array,
      default() {
        return [];
      },
    },
    getData: {
      type: Function,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      projectPath: '',
      formLabelAlign: {
      },
      selectedProject: null,
      list: [],
      props: this.searchArray.map(item => item.props),
    };
  },
  watch: {
    searchArray: {
      handler(newValue, oldValue) {
        // 代码操作
      },
      deep: true,
    },
    '$route.query': {
      handler(newValue, oldValue) {
        const { props } = this;
        const queries = props.reduce((map, item) => {
          if (newValue[item] !== undefined) {
            map[item] = newValue[item];
          }
          return map;
        }, {});
        this.formLabelAlign = queries;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {

  },
  methods: {
    resetForm() {
      this.formLabelAlign = {};
      this.onSubmit();
    },
    onSubmit(e, formData) {
      this.$emit('getData', formData, true);
    },
  },
};
</script>

<style lang="scss" scoped>
.searchCommon {
  display: flex;
  height: 60px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.search {
  flex: none;
  display: flex;
  height: 60px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.el-form-item {
  margin-bottom: 0;
}
.searchButton {
  margin-left: 30px;
  min-width: 150px;
}
.btn {
  margin-left: 20px;
}
</style>
